export const pixel = ( size : number, width : number = 1440 ) => {
    return `${(size / width) * 100}vw`;
}